import { useContext } from 'react'

import AbFtContext from 'containers/App/components/AbFtProvider/AbFtContext'


const useAb = () => useContext(AbFtContext)


export default useAb
